export interface BuildInfo {
    buildNumber: string | null;
    buildDateUtc: Date | null;
}

export interface BuildInfoEnvironment {
    VITE_BUILD_NUMBER?: string;
    VITE_BUILD_DATE_UTC?: string;
}

const UTC_ISO_TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

export function resolveBuildInfo(environment: BuildInfoEnvironment): BuildInfo {
    const buildNumber = normalizeBuildNumber(environment.VITE_BUILD_NUMBER);
    const buildDateUtc = parseBuildDateUtc(environment.VITE_BUILD_DATE_UTC);

    return Object.freeze({
        buildNumber,
        buildDateUtc,
    });
}

function normalizeBuildNumber(value: string | undefined): string | null {
    const normalizedValue = value?.trim();
    return normalizedValue || null;
}

function parseBuildDateUtc(value: string | undefined): Date | null {
    const normalizedValue = value?.trim();
    if (!normalizedValue || !UTC_ISO_TIMESTAMP.test(normalizedValue)) {
        return null;
    }

    const parsedValue = new Date(normalizedValue);
    const normalizedIsoValue = normalizedValue.replace(/Z$/, '.000Z');

    return !Number.isNaN(parsedValue.getTime()) && parsedValue.toISOString() === normalizedIsoValue
        ? parsedValue
        : null;
}

const viteEnvironment = import.meta.env as BuildInfoEnvironment | undefined;

export const buildInfo = resolveBuildInfo(viteEnvironment || {});
